import styled from "styled-components";
import { theme } from "ui/themes";

export const Container = styled.div`
  width: fit-content;
  display: flex;
  position: relative;
  z-index: 2;

  @media ${theme.device.desktopFirst.mobileL} {
    margin-bottom: 2rem;
  }
`;

export const Text = styled.div`
  display: flex;
  font-size: 1.2rem;
  font-weight: ${theme.typography.fontWeight["500"]};
  cursor: pointer;
  user-select: none;
  text-decoration: underline;
  color: ${theme.colors.neutral["670"]};
  font-size: 1.125rem;
`;
